import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Nav from '../navcomun';
import fondoCancha from '../../../Assets/fondo-cancha.jpg';

const preguntas = [
  {
    pregunta: '¿Cómo puedo unirme a un partido?',
    respuesta: 'Podés unirte desde la sección "Partidos" y seleccionando "Me meto", esto notificara al organizador que podra cottactarte o simplemente aceptarte. Recorda cada pertido tiene sus detalles como por ejemplo si es F5, F11 o si es Masculino/Fenenino/mixto'
  },
  {
    pregunta: '¿Cómo agrego a un jugador a mi equipo?',
    respuesta: 'Tienes varias opciones para agregar jugadores. Desde la sección "Jugadores" podés invitar juagdores directamente. Sino puedes crear un partido publico  recibir solicitudes de  jugadores para sumarse'
  },
  {
    pregunta: 'Recibi una notificacion para sumarse alguien a mi partido publico¿que hago?',
    respuesta: 'Si deseas  puedes aceptar directamente desde las notificaciones o solicitudes, si necesitas coordinar puedes enviar un mensaje de whatsap al solicitante'
  },
  {
    pregunta: 'Elegi ser un jugador pago o que prefiere no pagar la cancha,¿puedo sumarme a partidos publicos?',
    respuesta: 'Si, esta es solo una referencia a la hora de buscar jugadores para que el organizador sepa tus preferencias pero no es algo que te impida.'
  },
  {
    pregunta: '¿Puedo crear mis propios partidos?',
    respuesta: 'Sí, desde la sección "Crear Partido" podés organizar uno nuevo. Recuerda detallar lo mas posible tus preferencias'
  }
];

const PreguntasFrecuentes = () => {
  return (
    <>
      <Nav />
      <div
        style={{
          backgroundImage: `url(${fondoCancha})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          minHeight: '100vh',
          padding: '16px'
        }}
      >
        <Container maxWidth="sm" sx={{ backgroundColor: 'rgba(255, 255, 255, 0.95)', borderRadius: 2, p: 2 }}>
          <Typography variant="h5" align="center" fontWeight="bold" gutterBottom>
            Preguntas Frecuentes
          </Typography>

          {preguntas.map((item, index) => (
            <Accordion key={index} sx={{ mb: 1 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography fontWeight="bold">{item.pregunta}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>{item.respuesta}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Container>
      </div>
    </>
  );
};

export default PreguntasFrecuentes;
